import styled from 'styled-components';
import { Container } from '~/components/layout';

export const CustomerDetailsContainer = styled(Container)`
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-radius: 8px;

  ${props => props.theme.media.tabletLandscapeUp} {
    flex-direction: row;
  }
`;
